import React, { useMemo } from "react";
import { Box } from "@mui/material";
import qrcode from "qrcode-generator";

// A QR code drawn as SVG in the browser (qrcode-generator, MIT, no
// dependencies). The text never leaves the page: the SRT panel's codes carry
// the session passphrase.
export function QrCode({ text, size = 196, label = "QR code" }) {
  const { path, count } = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    let d = "";
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) if (qr.isDark(r, c)) d += `M${c + 4},${r + 4}h1v1h-1z`;
    }
    return { path: d, count: n + 8 };   // 4 modules of quiet zone on each side
  }, [text]);
  return (
    <Box component="svg" viewBox={`0 0 ${count} ${count}`} role="img" aria-label={label}
      // Never wider than its box: it shrinks with a narrow card or a phone.
      sx={{ width: size, maxWidth: "100%", height: "auto", aspectRatio: "1 / 1", display: "block", flexShrink: 0,
        borderRadius: "8px", bgcolor: "#FFFFFF" }}
      shapeRendering="crispEdges">
      <rect width={count} height={count} fill="#FFFFFF" />
      <path d={path} fill="#000000" />
    </Box>
  );
}
